const ATTEMPT_SCORE_FILTER = {
    ALL: 0,
    HIGHEST: 1,
    LOWEST: 2
}

const ATTEMPT_SCORE_FILTER_LABELS = {
    [ATTEMPT_SCORE_FILTER.ALL]: 'Todas las evaluaciones',
    [ATTEMPT_SCORE_FILTER.HIGHEST]: 'Resultado más alto',
    [ATTEMPT_SCORE_FILTER.LOWEST]: 'Resultado más bajo'
}

export { ATTEMPT_SCORE_FILTER, ATTEMPT_SCORE_FILTER_LABELS };
